/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'cvlib';
import { useDispatch, useSelector } from 'react-redux';
import { hidePinForm } from 'containers/PinForm/actions/pinForm.actions';
import { activateChannelPin } from 'containers/EPG/actions/channelBlocker/blocker.actions';

const style = {
  width: '136px',
  height: '40px',
  fontSize: '14px',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.35rem',
};

const CreatePinForm = props => {
  const dispatch = useDispatch();
  const channelPinStatus = useSelector(
    state => state.cvEpg.channelBlocker.activateChannelPin,
  );
  const translations = useSelector(state => state.translations);
  const translate = key =>
    translations[key] !== undefined ? translations[key] : key;
  const {
    onNextClicked = pinValue => {
      // dispatch(activateControlPin({ pin_code: pinValue, pin_channel: 1 }));
      dispatch(activateChannelPin(pinValue));
    },
    onSuccess,
    onCancelClicked = () => dispatch(hidePinForm()),
    title,
  } = props;

  const pinMessages = {
    noRightLength: translate('modal_activate_pin_message'),
    invalid: translate('lockChannel_tooltip_valid_label_validation'),
  };

  const [value, setValue] = useState('');
  const [currentError, setCurrentError] = useState(null);

  useEffect(
    () => {
      if (channelPinStatus.inProgress === false) {
        if (
          channelPinStatus.success === true &&
          channelPinStatus.data.update_accomplishment_status.channel_pin === 1
        ) {
          onSuccess();
        } else {
          console.log('Error en la modifycontrolpin');
        }
      }
    },
    [channelPinStatus.inProgress],
  );

  const handleSubmit = () => {
    if (value.trim().length < 6) {
      setCurrentError(pinMessages.noRightLength);
    } else {
      onNextClicked(value);
    }
  };

  const elements = [
    {
      element: 'subtitle',
      content: title,
      style: { paddingTop: '1.75rem' },
    },
    {
      element: 'item',
      expand: 3,
      position: 'center',
      type: 'pin',
      message: translate('email_tooltip_valid_label_validation'),
      error: currentError,
      name: 'emailRegister',
      id: 'emailRegister',
      autoFocus: true,
      handleSubmit,
      onChange: newValue => {
        setValue(newValue);
        setCurrentError(null);
      },
    },
    {
      element: 'group',
      direction: 'horizontal',
      expand: 1,
      style: { width: '264px' },
      children: [
        {
          element: 'button',
          type: 'gray',
          content: translate('register_access_option_button_cancel'),
          onClick: onCancelClicked,
          expand: 1,
          style,
          className: 'grayButton',
        },
        {
          element: 'button',
          type: 'red',
          content: translate('register_access_option_button_next'),
          dimmed: value.trim().length < 6,
          expand: 1,
          style: { ...style, marginLeft: '16px' },
          className: 'redButton',
          onClick: handleSubmit,
        },
      ],
    },
  ];

  return <Form elements={elements} classes={['pin-form-container']} />;
};

CreatePinForm.propTypes = {
  title: PropTypes.string,
  onCancelClicked: PropTypes.func.isRequired,
  onNextClicked: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
};

CreatePinForm.defaultProps = {
  title: 'Ingresa tu PIN de seguridad para bloquar este canal',
};

export default CreatePinForm;
